// src/components/SimpleEntityDialog.js
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material';

function SimpleEntityDialog({ open, onClose, onSave, title, label, initialItem }) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) {
      if (initialItem) {
        setValue(initialItem.name || '');
      } else {
        setValue('');
      }
    }
  }, [open, initialItem]);

  const handleSave = () => {
    if (!value) { alert(`Vui lòng nhập ${label}.`); return; }
    onSave({ name: value });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label={label} fullWidth value={value} onChange={(e) => setValue(e.target.value)} sx={{mt: 1}}/>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Hủy</Button><Button onClick={handleSave} variant="contained">Lưu</Button></DialogActions>
    </Dialog>
  );
}
export default SimpleEntityDialog;